import { TILE_STYLES, DEFAULT_TILE_STYLE } from "../../config/appTiles";

const CardApp = ({ application }) => {
  const { slug, name, description, url } = application;
  const style = TILE_STYLES[slug] || DEFAULT_TILE_STYLE;

  return (
    <a
      href={url}
      className="app-tile nounderline"
      style={{ "--tile-bg": style.bg, "--tile-fg": style.fg }}
      aria-label={name}
    >
      <div className="icon-wrap" aria-hidden="true">
        <i className={`la ${style.icon}`}></i>
      </div>
      <div className="text-wrap">
        <h2 className="tile-title">{name}</h2>
        <p className="tile-subtitle">{description}</p>
      </div>
    </a>
  );
};

export default CardApp;
